/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />


//Used as an attribute on the first input that should have focus
module Meevo.Components.Controls {
    "use strict";

    export class MeevoAutoScroller implements angular.IDirective {
        restrict = "A";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var container = angular.element(attrs['containerSelector']);
            var isEditing = attrs['editing'];

            if (isEditing == "true") {
                container.scrollTop(element.offset().top);
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoAutoScroller();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoAutoScroller", MeevoAutoScroller.factory());
}